import React, { useState } from 'react'
import { connect } from 'react-redux'
import { storageThumbUrl } from '../../firebase'

// Renders the player's initials as a base layer and, when the account has an image for the
// player, overlays the photo on top. If the photo fails to load (or doesn't exist) the
// image is hidden and the initials behind it stay visible.
function PlayerThumb({ player = {}, uuid }) {
  const [failed, setFailed] = useState(false)

  const initials = (player.name || '')
    .split(' ')
    .filter(Boolean)
    .map((n) => n[0].toUpperCase())
    .join('')
    .substr(0, 2)

  const src =
    uuid && player.img
      ? storageThumbUrl(`user/${uuid}/player/${player.img}/thumb.jpeg`)
      : null

  return (
    <span className="thumb">
      <span className="player-initials thumb-fallback">{initials}</span>
      {src && !failed && (
        <img
          className="player-thumb thumb-image"
          src={src}
          alt="Player"
          onError={() => setFailed(true)}
        />
      )}
    </span>
  )
}

const mapStateToProps = (state) => ({
  uuid: state.auth.uuid,
})

export default connect(mapStateToProps)(PlayerThumb)
